import { render, staticRenderFns } from "./royalty.vue?vue&type=template&id=08f33820&scoped=true"
import script from "./royalty.vue?vue&type=script&lang=js"
export * from "./royalty.vue?vue&type=script&lang=js"
import style0 from "./royalty.vue?vue&type=style&index=0&id=08f33820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f33820",
  null
  
)

export default component.exports